import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 pt-3\"><div class=\"banner-content text-center\"><h2 class=\"mt-3 pt-4\">Success! You have verified your Work Pages profile</h2><span></span></div></div></div></div><div class=\"login-area pt-120 mb-120\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"></div></div></div></div>", 2)
const _hoisted_3 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}